'use client'
import { TagLabel as ChakraTagLabel } from '@chakra-ui/react'
import { forwardRef, LegacyRef } from 'react'

import { TagLabelProps } from './TagLabel.types'

export default forwardRef(function TagLabel(
  props: TagLabelProps,
  ref: LegacyRef<HTMLSpanElement>
) {
  return <ChakraTagLabel {...props} ref={ref} translate="no" />
})
